import axios from 'axios'
import * as Util from '@/vuex/util'

let defaultState = []

const state = {
  ranks: defaultState
}

const mutations = {
  FETCH (state, params) {
    axios.get(Util.makeApiFilterUrl(params.slug, params.filters)).then(function (response) {
      state.ranks = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.ranks = defaultState
  }
}

const actions = {
  fetch: function ({commit}, params) {
    commit('FETCH', params)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.ranks
}

export const DamageCostsRank = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/barCharts/DamageCostsRank.js